import { render, staticRenderFns } from "./UploadDropIcon.vue?vue&type=template&id=5c673f29"
import script from "./UploadDropIcon.vue?vue&type=script&lang=js"
export * from "./UploadDropIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports